import { lazy } from "react";

import type { RouteConfig } from "../types";
import { RedirectToOnboarding } from "../redirects";

const OnboardingView = lazy(() => import("views/onboarding"));

export const getOnboardingRoutes = (): RouteConfig[] => [
  { path: "/onboarding", component: OnboardingView },
  { path: "*", component: RedirectToOnboarding }
];
